(function () {

  const metalBg = (value) => {
    const v = (value || "").toLowerCase();
    if (v.includes("white")) return "#e8edf2";
    if (v.includes("yellow")) return "#f3d58a";
    if (v.includes("rose")) return "#f0b08d";
    return "#eee";
  };

  const hasMetalColors = (values) => {
    return values.some(v =>
      v.toLowerCase().includes("white") ||
      v.toLowerCase().includes("yellow") ||
      v.toLowerCase().includes("rose")
    );
  };

  const formatCarat = (val) => {
    const cleaned = (val || "").toString().replace(/ct/ig, "").trim();
    const num = parseFloat(cleaned);
    return Number.isFinite(num) ? num.toFixed(2).replace(/\.00$/, "") : cleaned;
  };

  const formatInch = (val) => {
    const cleaned = (val || "")
      .toString()
      .toLowerCase()
      .replace(/inches/ig, "")
      .replace(/inch/ig, "")
      .replace(/"/g, "")
      .trim();

    const num = parseFloat(cleaned);
    if (Number.isFinite(num)) {
      return (Math.round(num * 100) / 100).toString();
    }
    return cleaned;
  };

  const init = (root) => {

    root.querySelectorAll("[data-bt-variant-ui]").forEach((wrap) => {

      const selectedMetalEl = wrap.querySelector("[data-bt-selected-metal]");
      const selectedDiamondEl = wrap.querySelector("[data-bt-selected-diamond]");
      const selectedSizeEl = wrap.querySelector("[data-bt-selected-size]");
      const selectedChainEl = wrap.querySelector("[data-bt-selected-chain]");

      // Paint metal swatches
      wrap.querySelectorAll("[data-bt-metal]").forEach((label) => {
        label.style.background = metalBg(label.dataset.btMetal);
      });

      const hiddenPicker = wrap.closest(".product__info-container, .product__info-wrapper, .product__info")
        ?.querySelector(".bt-hidden-variant-picker");

      if (!hiddenPicker) return;

      const setHiddenOption = (value) => {
        const selects = hiddenPicker.querySelectorAll("select");

        for (const sel of selects) {
          const opt = [...sel.options].find(o => o.value === value || o.text === value);
          if (opt) {
            sel.value = opt.value;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }

        const radios = hiddenPicker.querySelectorAll('input[type="radio"]');

        for (const r of radios) {
          if (r.value === value) {
            r.checked = true;
            r.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
      };

      const syncTitles = () => {
        const metalChecked = wrap.querySelector('[data-bt-block="metal"] input:checked');
        const diamondChecked = wrap.querySelector('[data-bt-block="diamond"] input:checked');
        const sizeChecked = wrap.querySelector('[data-bt-block="size"] input:checked');
        const chainChecked = wrap.querySelector('[data-bt-block="chain-length"] input:checked');

        if (selectedMetalEl && metalChecked) {
          selectedMetalEl.textContent = metalChecked.value;
        }

        if (selectedDiamondEl && diamondChecked) {
          selectedDiamondEl.textContent = ` ${formatCarat(diamondChecked.value)} Carat`;
        }

        if (selectedSizeEl && sizeChecked) {
          selectedSizeEl.textContent = ` ${formatInch(sizeChecked.value)} Inch`;
        }

        if (selectedChainEl && chainChecked) {
          selectedChainEl.textContent = ` ${formatInch(chainChecked.value)} Inch`;
        }
      };

      // AUTO SELECT FIRST METAL ONLY IF NO COLOR TYPE
      const metalInputs = wrap.querySelectorAll('[data-bt-block="metal"] input');

      if (metalInputs.length) {
        const values = [...metalInputs].map(i => i.value);

        if (!hasMetalColors(values)) {
          const first = metalInputs[0];
          first.checked = true;
          setHiddenOption(first.value);

          if (selectedMetalEl) {
            selectedMetalEl.textContent = first.value;
          }
        }
      }

      // USER CHANGE
      wrap.addEventListener("change", (e) => {
        if (e.target.matches('[data-bt-input]')) {
          setHiddenOption(e.target.value);
          syncTitles();
        }
      });

      // initial sync on load
      syncTitles();

    });

  };

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (e) => init(e.target));

})();